const SHOP_DATA = {
  shops: [
    {
      id: 0,
      shop_name: "Tsubaki création",
      shop_name_lowercase_no_spaces_for_url: "tsubakicreation",
      shop_icon_url:
        "https://i.ibb.co/MM5sqsj/Screenshot-2023-08-11-184555.jpg",
      shop_website_url:
        "https://www.instagram.com/tsubaki.creation/?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
      shop_purchase_website_url: "https://tsubaki-creation.sumupstore.com/",
      shop_headline: "Créatrice de sacs et accessoires en tissu japonais",
      shop_intro_text:
        "Tsubaki Création  confectionne des créations textiles authentiques et originales, dont les tissus  viennent du Japon.  Vous pouvez trouver des sacs et des accessoires que vous pouvez utiliser, facilement, tous les jours !",

      shop_email: "",
    },
    {
      id: 1,
      shop_name: "Nami Créations",
      shop_name_lowercase_no_spaces_for_url: "namicreations",
      shop_image_url: "https://i.ibb.co/RTVB88N/7843.jpg",
      shop_icon_url: "https://i.ibb.co/pv6dvJF/namicreation-1.jpg",
      shop_website_url: "https://www.nami-creations.fr/",
      shop_purchase_website_url: "",
      shop_headline: "Auteure manga et créatrice d'objets en papier",
      shop_intro_text:
        "Nami Créations est une entreprise individuelle créée début 2015 et basée à Tours.\nElle est spécialisée dans la fabrication artisanale de manga et yonkoma manga (comic strip japonais), recettes japonaises à dérouler et kirigami (papier découpé).\nNami est l'auteure des dessins et scenarii des livres qu'elle réalise entièrement à la main (découpe, collage, reliure).",

      shop_email: "",
    },
    {
      id: 2,
      shop_name: "GOEN",
      shop_name_lowercase_no_spaces_for_url: "goen",
      shop_image_url: "https://i.ibb.co/Cn80MbW/317708.jpg",
      shop_icon_url:
        "https://i.ibb.co/sFJ540V/313079373-187425353851045-7210455388149182739-n.jpg",
      shop_website_url: "https://www.instagram.com/goenjpfr/",
      shop_purchase_website_url: "https://goen.sumupstore.com/",
      shop_headline: "Créateur de bijoux japonais",
      shop_intro_text: "Créateur de bijoux à partir de l'origami japonais ",

      shop_email: "",
    },
    {
      id: 3,
      shop_name: "AT bijoux",
      shop_name_lowercase_no_spaces_for_url: "atbijoux",
      shop_image_url: "https://i.ibb.co/CbPqQdD/1.jpg",
      shop_icon_url:
        "https://i.ibb.co/55vzdb5/Screenshot-2023-08-11-184044.jpg",
      shop_website_url: "http://www.atbijoux.com",
      shop_purchase_website_url: "",
      shop_headline: "Créatrice de bijoux en soie",
      shop_intro_text:
        "Toutes les pièces d'AT bijoux sont fabriquées à la main selon la méthode de couture traditionnelle japonaise avec des fils de soie importés du Japon.\nIl faut du temps, de la précision et de la patience ",

      shop_email: "",
    },
    {
      id: 4,
      shop_name: "SUGAR",
      shop_name_lowercase_no_spaces_for_url: "sugar",
      shop_image_url: "",
      shop_icon_url:
        "https://i.ibb.co/N2mPPKx/Screenshot-2023-08-12-180643.jpg",
      shop_website_url: "https://sugarlike.jp/",
      shop_purchase_website_url: "https://sugarlike.jp/",
      shop_headline: "Boutique de produits traditionnels japonais",
      shop_intro_text:
        "SUGAR est une toute nouvelle entreprise d'origine japonaise dont l'objectif est de promouvoir l'artisanat traditionnel et les spécialités régionales à l'étranger. Au travers son catalogue de produits, notre équipe franco-nippone souhaite vous faire découvrir avec passion, les multiples facettes de l'histoire du Japon et ce qui reste de celle-ci.\nNos produits sont confectionnés par des artisans locaux du pays du soleil levant. Chaque produit possède une touche artistique propre à chaque créateur. Vous découvrirez un panel d'objets d'une époque passée et les techniques utilisées. \nMais également les objets contemporains qui font tout le charme de la culture du pays.",

      shop_email: "",
    },
    {
      id: 5,
      shop_name: "Biscuits o riz",
      shop_name_lowercase_no_spaces_for_url: "biscuitsoriz",
      shop_image_url: "",
      shop_icon_url: "https://i.ibb.co/GQ08w16/17583-small.jpg",
      shop_website_url: "https://www.biscuitsoriz.com/index.php",
      shop_purchase_website_url: "",
      shop_headline:
        "Fondée en 2016, Biscuits o riz propose un panel varié de biscuits à base de farine de riz.",
      shop_intro_text:
        "Fondée en 2016, Biscuits o riz propose un panel varié de biscuits à base de farine de riz. \nNos créations sucrées et salées, naturellement sans gluten, sont fabriquées artisanalement au coeur de la Touraine.",

      shop_email: "",
    },
    {
      id: 6,
      shop_name: "FUMIHITO ONDA Massage",
      shop_name_lowercase_no_spaces_for_url: "fumihitoondamassage",
      shop_image_url: "",
      shop_icon_url: "https://i.ibb.co/SVV1qHt/img-for-icon.jpg",
      shop_website_url: "",
      shop_purchase_website_url: "",
      shop_headline:
        "Massage utilisant les méridiens et les points de pression pour stimuler le corps, soulager les tensions et améliorer la circulation de l'énergie. Un essai de massage 15mins 10euro",
      shop_intro_text:
        "Massage utilisant les méridiens et les points de pression pour stimuler le corps, soulager les tensions et améliorer la circulation de l'énergie. Un essai de massage 15mins 10euro",

      shop_email: "",
    },
  ],
};

export default SHOP_DATA;
